<script setup lang="ts">
import { Eye, MessageCircleHeart, Tag, Zap } from 'lucide-vue-next';

const prefix = 'components.home.optionwayChart';
</script>

<template>
  <div class="grid w-full grid-cols-1 justify-items-center gap-10">
    <div class="flex flex-col items-center gap-6 text-center">
      <i18n-t
        scope="global"
        :keypath="`${prefix}.subtitle`"
        tag="h2"
        class="text-2xl font-semibold leading-tight text-text-primary-900 md:text-3xl"
      >
        <template #accent>
          <span class="text-brand-primary-700">{{ $t(`${prefix}.subtitleAccent`) }}</span>
        </template>
      </i18n-t>
      <p class="text-sm font-normal text-text-secondary-600">
        {{ $t(`${prefix}.tagline`) }}
      </p>
    </div>

    <div class="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
      <div class="group flex items-start gap-4 rounded-2xl border border-gray-300 p-4 sm:p-6 lg:flex-col">
        <div
          class="inline-flex size-12 shrink-0 items-center justify-center rounded-xl bg-brand-primary-50 transition-transform duration-500 xl:group-hover:scale-125"
        >
          <Tag
            class="size-5 text-brand-primary-700"
            :stroke-width="2"
            aria-hidden="true"
          />
        </div>
        <div class="flex flex-col gap-1.5">
          <h3 class="font-semibold text-text-primary-900">
            {{ $t(`${prefix}.price`) }}
          </h3>
          <p class="text-sm font-normal leading-snug text-text-secondary-600">
            {{ $t(`${prefix}.priceDescription`) }}
          </p>
        </div>
      </div>

      <div class="group flex items-start gap-4 rounded-2xl border border-gray-300 p-4 sm:p-6 lg:flex-col">
        <div
          class="inline-flex size-12 shrink-0 items-center justify-center rounded-xl bg-brand-primary-50 transition-transform duration-500 xl:group-hover:scale-125"
        >
          <MessageCircleHeart
            class="size-5 text-brand-primary-700"
            :stroke-width="2"
            aria-hidden="true"
          />
        </div>
        <div class="flex flex-col gap-1.5">
          <h3 class="font-semibold text-text-primary-900">
            {{ $t(`${prefix}.assistance`) }}
          </h3>
          <p class="text-sm font-normal leading-snug text-text-secondary-600">
            {{ $t(`${prefix}.assistanceDescription`) }}
          </p>
        </div>
      </div>

      <div class="group flex items-start gap-4 rounded-2xl border border-gray-300 p-4 sm:p-6 lg:flex-col">
        <div
          class="inline-flex size-12 shrink-0 items-center justify-center rounded-xl bg-brand-primary-50 transition-transform duration-500 xl:group-hover:scale-125"
        >
          <Eye
            class="size-5 text-brand-primary-700"
            :stroke-width="2"
            aria-hidden="true"
          />
        </div>
        <div class="flex flex-col gap-1.5">
          <h3 class="font-semibold text-text-primary-900">
            {{ $t(`${prefix}.transparency`) }}
          </h3>
          <p class="text-sm font-normal leading-snug text-text-secondary-600">
            {{ $t(`${prefix}.transparencyDescription`) }}
          </p>
        </div>
      </div>

      <div class="group flex items-start gap-4 rounded-2xl border border-gray-300 p-4 sm:p-6 lg:flex-col">
        <div
          class="inline-flex size-12 shrink-0 items-center justify-center rounded-xl bg-brand-primary-50 transition-transform duration-500 xl:group-hover:scale-125"
        >
          <Zap
            class="size-5 text-brand-primary-700"
            :stroke-width="2"
            aria-hidden="true"
          />
        </div>
        <div class="flex flex-col gap-1.5">
          <h3 class="font-semibold text-text-primary-900">
            {{ $t(`${prefix}.simplicity`) }}
          </h3>
          <p class="text-sm font-normal leading-snug text-text-secondary-600">
            {{ $t(`${prefix}.simplicityDescription`) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
